import React from 'react'
import ListContacts from '../../../react4xp/components/ListContacts'


function ListContactsPart({title, intro, contacts, revealEmailString}) {
	return <ListContacts
		title={title}
		intro={`<p>${intro}</p>`}
		contactCard={contacts?.map(contact => ({
			image: contact.image?.link && {
				src: contact.image.link,
				alt: contact.image.alt
			},
			name: contact.name,
			position: contact.position,
			email: contact.email && {
				isVisible: false,
				revealText: revealEmailString,
				email: contact.email
			}
		}))}
	/>
}

export default (props) => <ListContactsPart {...props} />
